import { Component } from '@angular/core';
import { ComponentFormComponent } from "../component-form/component-form.component";
import { ClrIconModule } from "@clr/angular";
import { Router, RouterLink } from "@angular/router";
import { ClarityIcons, twoWayArrowsIcon } from "@cds/core/icon";
import { Components } from "../../../_shared/interfaces";

import { environment as env } from "../../../../environments/environment";

@Component({
  selector: 'app-component-add',
  standalone: true,
  imports: [
    RouterLink,
    ClrIconModule,
    ComponentFormComponent
  ],
  templateUrl: './component-add.component.html',
  styleUrl: './component-add.component.sass'
})
export class ComponentAddComponent {
  devMode: boolean;

  constructor(
    private router: Router
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon);
    this.devMode = env.stages.dev;
  }

  onComponentAdded(component: Components) {
    // Nach erfolgreicher Erstellung zur Übersicht navigieren
    this.router.navigate(['/component/overview/true']);
  }
}
